/**
 * Pendo API keys per app slug. Keys are issued manually in the Pendo admin
 * console and injected at build time (set-pendo-keys.sh exports the env vars
 * in CI from the GCP secret `pendo-api-keys`). Apps without an entry simply
 * run without Pendo — usePendoPortal no-ops on a missing key.
 */
export const PENDO_KEYS_BY_SLUG: Record<string, string | undefined> = {
  'agency-intelligence-platform': process.env['NX_PUBLIC_AIP_PENDO_KEY'],
  'distributor-inventory-platform': process.env['NX_PUBLIC_DIP_PENDO_KEY'],
  'distributor-platform': process.env['NX_PUBLIC_DP_PENDO_KEY'],
  'daap-syndicated-reporting': process.env['NX_PUBLIC_DSP_PENDO_KEY'],
};
